module.exports = __webpack_public_path__ + "media/images/icons/dots-slanted-green-7c8cb50658f05ea1de128c55df5b42c1.svg";